"use client";

import React from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const ecosystemNodes = [{
  label: "NODE_01",
  title: "Healthcare Network",
  description: "A growing network of healthcare partnerships, medical institutions and strategic collaborations forming the real-world foundation of the AizaHcare ecosystem.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1581901/img/exterior_medical_center.png"
}, {
  label: "NODE_02",
  title: "Real Patient Data",
  description: "Patient data sourced through healthcare partnerships, existing datasets and future deployments, continuously improving our AI models and healthcare outcomes.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1581901/img/ecosystem_patient_health_data.png"
}, {
  label: "NODE_03",
  title: "AI Models",
  description: "Artificial intelligence models trained on real clinical data to generate predictive healthcare insights and decision support.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1581901/img/ai_predictive_health_models.png"
}, {
  label: "NODE_04",
  title: "AI Healthcare Applications",
  description: "AI-native evolving healthcare solutions focused on diabetes, elder care, mental health and women’s health..",
  image: "https://positive-cattle.10web.cloud/wp-content/uploads/2026/03/ai_solutions_software_ui.webp"
}, {
  label: "NODE_05",
  title: "Sovereign AI Compute",
  description: "Sovereign cloud and AI compute infrastructure providing the processing power required to train and operate healthcare AI systems.",
  image: "https://positive-cattle.10web.cloud/wp-content/uploads/2026/03/sterile_server_room.webp?v=f1bsjlhkv6g"
}];
export default function TheAizahcareRealWorldEcosystem() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.5
  });
  const {
    ref: gridRef,
    isVisible: isGridVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section id="the-aizahcare-real-world-ecosystem" className="bg-background py-[160px] overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div ref={headerRef} className={cn("mx-auto max-w-3xl text-center mb-20 transition-all duration-1000 ease-out", isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12")}>
          <h2 className="font-sans text-4xl md:text-5xl lg:text-6xl font-bold text-primary tracking-normal mb-6">Real-World Healthcare Infrastructure</h2>
          <p className="font-sans text-lg md:text-xl text-muted-foreground leading-relaxed">The AizaHcare ecosystem connects medical centers, real patient data, artificial intelligence models and sovereign AI compute to build the next generation healthcare infrastructure powered by the Aizalea utility token.</p>
        </div>

        <div ref={gridRef} className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-6">
          {ecosystemNodes.map((node, i) => <div key={node.label} data-index={i} className={cn("transition-all duration-700 ease-out", isGridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-16")} style={{
          transitionDelay: `${i * 150}ms`
        }}>
              <Card className="h-full rounded-xl border border-border shadow-[0_10px_40px_0_rgba(0,0,0,0.08)] overflow-hidden group relative transition-transform duration-500 hover:-translate-y-2 bg-card">
                <div className="relative h-48 w-full overflow-hidden">
                  <img src={i === 2 ? "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1581901/img/ai_engineers_working.png" : i === 1 ? "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1581901/img/patient_clinical_data_records.png" : node.image} alt={i === 2 ? "AI engineers working" : node.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" />
                  {}
                  <div className="absolute inset-0 bg-ring/0 transition-colors duration-500 group-hover:bg-ring/20 mix-blend-overlay z-10" />
                </div>
                
                <CardHeader className="pt-6 pb-2 px-6 relative z-20 bg-card">
                  <span className="font-mono text-xs font-bold text-ring tracking-widest mb-2 block">
                    {node.label}
                  </span>
                  <CardTitle className="font-sans text-xl font-semibold text-foreground">
                    {node.title}
                  </CardTitle>
                </CardHeader>
                
                <CardContent className="px-6 pb-6 relative z-20 bg-card">
                  <CardDescription className="font-sans text-sm text-muted-foreground leading-relaxed">
                    {node.description}
                  </CardDescription>
                </CardContent>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}